export default "__VITE_ASSET__ac10b204__"